module.exports = __webpack_public_path__ + "static/media/aboutus-1 7.73843a4f.png";